export type DebouncedFn<T extends (...args: Parameters<T>) => void> = T & { cancel: () => void };

export function debounce<T extends (...args: Parameters<T>) => void>(fn: T, ms: number): DebouncedFn<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const debounced = (...args: Parameters<T>) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), ms);
  };
  debounced.cancel = () => clearTimeout(timer);
  return debounced as DebouncedFn<T>;
}
